import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryCards from './components/CategoryCards';
import FeaturedMovies from './components/FeaturedMovies';
import MovieRanking from './components/MovieRanking';
import LatestMovies from './components/LatestMovies';
import ArticleSection from './components/ArticleSection';

export default function Home() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '68影院',
    url: 'https://www.68cinema.com',
    description: '68影院提供电影大全片库，涵盖最新电影、热门电影排行榜，支持高清免费在线观看不缓冲',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.68cinema.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const webPageLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '68影院 - 电影大全 | 最新电影高清免费在线观看',
    description: '68影院🌟提供电影大全片库，涵盖最新电影、🎭热门电影排行榜，支持高清免费在线观看不缓冲',
    url: 'https://www.68cinema.com',
    isPartOf: {
      '@type': 'WebSite',
      name: '68影院',
      url: 'https://www.68cinema.com',
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageLd) }}
      />
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryCards />
        <FeaturedMovies />
        <MovieRanking />
        <LatestMovies />
        <ArticleSection />
      </main>
      <Footer />
    </>
  );
}